import React from 'react';
import PropTypes from 'prop-types';

const emojiComponent = (props) => {
  return /* @__PURE__ */ React.createElement("span", { style: { fontFamily: "cursive" } }, props.children);
};
emojiComponent.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element)
};

export { emojiComponent };
//# sourceMappingURL=emojiComponent.js.map
